import { gql } from '@apollo/client'

const UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION = gql`
  mutation updateIngredientAlternativeIngredientsDetails(
    $id: ID!
    $data: [IngredientAlternativeIngredientDetailsInput!]!
  ) {
    updateIngredientAlternativeIngredientsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      alternativeIngredients {
        alternativeIngredientId
        dietId
      }
    }
  }
`

export default UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION
